<template>
  <el-config-provider :locale="locale">
    <router-view/>
  </el-config-provider>
</template>

<script>
import i18n from "./i18n";
import {ElConfigProvider} from 'element-plus'

// 中文包
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from "element-plus/es/locale/lang/en";
import ja from "element-plus/es/locale/lang/ja";
import es from "element-plus/es/locale/lang/es";
import fr from "element-plus/es/locale/lang/fr";

let tid

export default {
  components: {
    [ElConfigProvider.name]: ElConfigProvider
  },
  data() {
    return {
      beforeWidth: 0
    }
  },
  computed: {
    locale() {
      switch (i18n.global.locale.value) {
        case 'zh':
          return zhCn;
        case 'en':
          return en;
        case 'ja':
          return ja;
        case 'es':
          return es;
        case 'fr':
          return fr;
        default:
          return zhCn;
      }
    }
  },
  // html加载完成之前
  created() {
    let that = this
    if (!this._isMobile()) {
      window.addEventListener('resize', function () {
        clearTimeout(tid)
        tid = setTimeout(that.refresh, 300)
      }, false)
    }
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        clearTimeout(tid)
        tid = setTimeout(that.refresh, 300)
      }
    }, false)
    that.refresh()
  },
  // 事件方法执行
  methods: {
    _isMobile() {
      return navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    },
    refresh() {
      let minWidth = 800
      let width = window.document.documentElement.getBoundingClientRect().width
      if (width < minWidth || this._isMobile()) {
        sessionStorage.setItem('mobile', '1')
        if (this.beforeWidth >= minWidth) {
          location.reload()
        }
      } else {
        sessionStorage.setItem('mobile', '0')
        if (this.beforeWidth !== 0 && this.beforeWidth < minWidth) {
          location.reload()
        }
      }
      this.beforeWidth = width
    }
  },
}
</script>
